export default {
  navContents: [],
};
